import React from "react";
import ProjectInformationView from "./view";

const ProjectInformationPage = () => {
  return <ProjectInformationView />;
};

export default ProjectInformationPage;